import { bootstrapApplication } from '@angular/platform-browser';
import { registerLicense } from '@syncfusion/ej2-base';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Registering Syncfusion license key and is only valid for version 33.x.x (This is not a secret)
registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXlcdHVUQ2hcUk11WkBWYE4=');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
